import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import CommonImage from '@components/common/CommonImage'
import CommonIconButton from '@components/common/CommonIconButton'
import CommonFormInput from '@components/common/CommonFormInput'
import CommonButton from '@components/common/CommonButton'
import { useUserContext } from '@hooks/useUserContext'
import { userApi } from '@api/api'
import { useHistory } from 'react-router'

const UserInfoPage = props => {
  const history = useHistory()
  const { state } = useUserContext()

  if (!state.user) {
    return <div>404</div>
  }
  const { username, fullName, image } = state.user
  const [userInfo, setUserInfo] = useState({
    username: '',
    fullName: '',
    password: '',
    passwordConfirm: '',
  })

  useMemo(() => {
    setUserInfo({
      ...userInfo,
      username,
      fullName,
    })
  }, [])

  const onChange = e => {
    const { name, value } = e.target
    setUserInfo({
      ...userInfo,
      [name]: value,
    })
  }

  const updatePassword = async () => {
    if (userInfo.password !== userInfo.passwordConfirm) {
      alert('비밀번호가 일치하지 않습니다!')
      return
    }

    try {
      await userApi.putUserPassword({
        password: userInfo.password,
      })

      alert('비밀번호가 정상적으로 변경되었습니다!')
      history.push('/main')
    } catch (e) {
      alert('비밀번호 변경 시, 문제가 발생했습니다!')
    }
  }

  const userInfoForm = [
    {
      name: 'password',
      type: 'password',
      label: '비밀번호',
      placeholder: '변경할 비밀번호를 입력해주세요',
      defaultValue: '',
    },
    {
      name: 'passwordConfirm',
      type: 'password',
      label: '비밀번호 확인',
      placeholder: '변경할 비밀번호를 다시 입력해주세요',
      defaultValue: '',
    },
  ]

  return (
    <>
      <div>
        <UserInfoPageStyle />
        <div className="img-wrapper">
          <CommonImage
            width={140}
            height={140}
            style={
              image
                ? { borderRadius: '100%', textAlign: 'center' }
                : {
                    borderRadius: '100%',
                    textAlign: 'center',
                    border: '2px solid #FFA34B',
                  }
            }
            src={image || require('../assets/images/404.png').default}
          />
        </div>
        <div className="form-wrapper">
          {userInfoForm.map(userInfo => (
            <CommonFormInput
              className="form-input"
              key={userInfo.name}
              name={userInfo.name}
              type={userInfo.type}
              width="100%"
              label={userInfo.label}
              placeholder={userInfo.placeholder}
              defaultValue={userInfo.defaultValue}
              disabled={userInfo.isImmutable}
              onChange={onChange}
            />
          ))}
          <CommonButton
            text="저장"
            width="100%"
            style={{ marginTop: '40px', marginBottom: '30px' }}
            onClick={updatePassword}
          />
        </div>
      </div>
    </>
  )
}

UserInfoPage.propTypes = {}

const UserInfoPageStyle = createGlobalStyle`
.img-wrapper{
  position: relative;
  width: 140px;
  margin: 0 auto;
  margin-top: 50px;
}

.icon-upload {
  position: absolute;
  bottom: 0;
  right: 0;
}

.form-input {
  margin-top: 25px;

  &:first-child {
    margin-top: 40px;
  }
}
`

export default UserInfoPage
